
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"25","height":"26","viewBox":"0 0 25 26","fill":"none"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M12.5 17.15a4.15 4.15 0 100-8.3 4.15 4.15 0 000 8.3z"}}),_c('path',{attrs:{"d":"M7.014 11.8A5.625 5.625 0 0112.5 7.384h11.175a12.525 12.525 0 00-2.336-3.224A12.418 12.418 0 0012.499.5C9.162.5 6.023 1.8 3.662 4.161c-.227.227-.444.462-.651.702L7.014 11.8z"}}),_c('path',{attrs:{"d":"M14.203 18.35a5.619 5.619 0 01-6.58-2.572c-.008-.01-.015-.02-.021-.031l-5.55-9.614A12.413 12.413 0 000 13c0 3.339 1.3 6.478 3.661 8.839a12.41 12.41 0 006.537 3.45l4.005-6.938z"}}),_c('path',{attrs:{"d":"M16.278 8.85a5.602 5.602 0 011.068 6.984l-.015.029-5.552 9.616a12.418 12.418 0 009.56-3.64A12.418 12.418 0 0025 13c0-1.436-.241-2.835-.703-4.15h-8.019z"}})])
          )
        }
      }
    